import PhotosThumbnailsGrid from './PhotosThumbnailsGrid';

export default PhotosThumbnailsGrid;
